module.exports = __webpack_public_path__ + "img/youtube.89c73ff4.svg";